import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { BsThreeDotsVertical } from "react-icons/bs";

import {
    Box,
} from "@mui/material";

import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../utils/const';

const columns = [
    {
        id: 'job_id',
        label: 'Job ID ',
        minWidth: 100,
    },
    {
        id: 'job_title',
        label: 'Job Title ',
        minWidth: 100,
    },

    {
        id: 'location',
        label: 'Location ',
        minWidth: 80,
    },
    {
        id: 'job_type',
        label: 'Hiring Mode ',
        minWidth: 80,
    },
    {
        id: 'created_at',
        label: 'Post Date',
        minWidth: 70,
    },

    {
        id: 'postreach',
        label: 'Post Reach ',
        minWidth: 50,
    },
    {
        id: 'email',
        label: 'E-mail Deliver ',
        minWidth: 50,
    },
];

export default function RecruiterListingTable({ postrequirementList }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const navigate = useNavigate();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (

        <Box style={{ backgroundColor: '#fff', padding: '5px 15px 15px 15px' }}>

            <Paper sx={{
                overflow: 'hidden'
            }}>
                <TableContainer sx={{ maxHeight: 640, }}>
                    <Table stickyHeader aria-label="sticky table" style={{ borderSpacing: '0 10px' }}>
                        <TableHead >
                            <TableRow>
                                <TableCell
                                    align='center'
                                    style={{ minWidth: 100, width: '20px', backgroundColor: '#BAD1E8', fontWeight: '600', fontSize: '14px', padding: '14px 14px 14px 1px' }}>
                                    No.
                                </TableCell>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth, backgroundColor: '#BAD1E8', fontWeight: '600', fontSize: '14px', padding: '14px 14px 14px 1px' }}
                                    >
                                        <span style={column.id === "slno" ? {} : { borderLeft: '1.5px solid #89a8c7', padding: '10px 1px 10px 10px' }}>
                                            {column.label}
                                        </span>
                                    </TableCell>
                                ))}
                                <TableCell style={{ width: '20px', backgroundColor: '#BAD1E8', fontWeight: '600', fontSize: '14px', padding: '14px 14px 14px 1px' }}>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {postrequirementList &&
                                postrequirementList
                                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    ?.map((row, index) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.name}>
                                                <TableCell
                                                    align='center'
                                                    style={{
                                                        fontSize: '14px',
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '15px',
                                                        fontFamily: 'Calibri',
                                                        color: 'inherit',
                                                        cursor: 'pointer',

                                                    }}>
                                                    {index + 1}
                                                </TableCell>
                                                {columns.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <TableCell
                                                            style={{
                                                                fontSize: '14.5px',
                                                                // fontWeight: 600,
                                                                // backgroundColor: '#DEEBF7',
                                                                backgroundColor: '#f8f9fa',
                                                                padding: '15px',
                                                                fontFamily: 'Calibri',
                                                                color:
                                                                    column.id === 'population' ? '#154e83' :
                                                                        column.id === 'density' ? '#00B050' :
                                                                            column.id === 'date' ? '#154e83' :
                                                                                'inherit',
                                                            }}
                                                            key={column.id}
                                                            align={column.align}
                                                        >
                                                            {column.format && typeof value === 'number'
                                                                ? column.format(value)
                                                                : column.id === "created_at" ? formatDate(value) : value}
                                                        </TableCell>

                                                    );
                                                })}
                                                <TableCell
                                                    style={{
                                                        fontSize: '14.5px',
                                                        // fontWeight: 600,
                                                        // backgroundColor: '#DEEBF7',
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '15px',
                                                        fontFamily: 'Calibri',
                                                        color: 'inherit',
                                                        cursor: 'pointer',
                                                        // textAlign:'center',
                                                    }}>
                                                    <Box variant="contained" size="large" onClick={() => navigate('/job-post-list-view', { state: { row: row, index: index, } })}><BsThreeDotsVertical /></Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={postrequirementList?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>



    );
}
